import {Component, OnInit} from '@angular/core';
import {UserService} from "../../../../../services/user.service";

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {

  limited = false;

  constructor(private userService: UserService,) {
  }

  ngOnInit() {
    this.userService.getInfo().subscribe(observe => {
      console.log(observe)
      if (observe) {
        if (observe.profile.finished) {
          this.limited = true;
        }
      }
    })


  }

}
